// Filter empty options in FormData
export const filterEmptyOptions = (key: string, data: FormData) => (
  data
    .getAll(key)
    .filter(val => !!val)
    .map(val => Number(val))
)
